require('webpack-jquery-ui/autocomplete');
require('webpack-jquery-ui/css'); 

export default class evermapsSearch
{
    constructor()
    {
        const evermaps = window.evermaps;
        
        if (typeof evermaps !== 'undefined' && typeof evermaps.onLoadJsLibrary === 'function') {

            evermaps.onLoadJsLibrary(function (e) {
                
                var language = 'fr';

                if (typeof evermapsCountry != 'undefined') {
                    language = evermapsCountry;
                }
                
                var $searchForm = $('#salon-form');
                var $searchField = $('#salon-field');
                var $localizeMe = $('#localize-me');
                
                var searchWidget = evermaps.customer.jeanlouisdavid.SearchWidget.create({
                    language: language
                });

                searchWidget.language = language;

                // fill country
                $.each(searchWidget.getCoveredCountries(), function (i, country) {
                    if (country.code == evermapsCountryId && evermapsCountryId != 1){
                        searchWidget.selectedCountry = country;
                    } else if (evermapsCountryId == 1) {
                        searchWidget.selectedCountry = evermapsCountryId;
                    }
                });
                
                // catch form submit
                $searchForm.submit(function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    var searchText = $searchField.val();
                    searchWidget.addressSearch(searchText)
                        .fail(function(error) {
                            alert('Une erreur est survenue');
                        })
                    ;
                });
                
                $searchField.autocomplete({
                    classes: {
                        'ui-autocomplete': 'em-search-form__autocomplete'
                    },
                    minLength: 3,
                    open: function () { 
                        $('ul li.ui-menu-item b').attr('class', '');
                    },
                    source: function(request, response) {
                        
                        searchWidget.addressSuggest(request.term, {
                            maxresults: 6
                        })
                            .done(function(data) {
                                var responseData = $.map(data, function(suggestion) {
                                    return {
                                        label: suggestion.label,
                                        suggestion: suggestion
                                    };
                                });
                                response(responseData);
                            })
                            .fail(function(error) {
                                alert('Une erreur est survenue');
                            })
                        ;
                    },
                    select: function(event, ui) {
                        event.preventDefault();
                        searchWidget.selectAddressSuggestion(ui.item.suggestion)
                            .fail(function(error) {
                                alert('Une erreur est survenue');
                            })
                        ;
                        $searchField.val(ui.item.suggestion.value);
                    }
                });
                
                if ($searchField.length) {
                    $searchField.data('ui-autocomplete')._renderItem = function(ul, item) {
                        return $('<li>').append(item.label).appendTo(ul);
                    };
                }
                
                $localizeMe.toggleClass('disabled', !searchWidget.isGeolocationCapable());
                $localizeMe.click(function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    searchWidget.geolocalize()
                        .fail(function(error) {
                            var ERROR_CODES = searchWidget.ERROR_CODES.GEOLOC;
                            switch (error) {
                                case ERROR_CODES.GEOLOC_UNAVAILABLE:
                                    alert('La géolocalisation est indisponible');
                                    break;
                                case ERROR_CODES.POSITION_UNAVAILABLE:
                                    alert('Impossible de récupérer votre position.');
                                    break;
                                case ERROR_CODES.PERMISSION_DENIED:
                                    alert('Impossible d\'accéder à la géolocalisation. Permission refusée');
                                    break;
                                case ERROR_CODES.TIMEOUT:
                                    alert('La géolocalisation est trop longue');
                                    break;
                                case ERROR_CODES.UNKNOWN_ERROR:
                                    alert('Erreur inconnue');
                                    break;
                                default:
                                    alert('Erreur inconnue');
                            }
                            
                        })
                    ;
                });
                
            
        
            });
        }
    }
}



// WEBPACK FOOTER //
// ./scripts/libs/evermaps/evermapsSearch.js